module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_tvb-bb018cd14c662230c1c426867e2a14ed.svg";